import {
  get,
  post,
  error,
} from '@/api/common.js'

function insertMessage(path, value) {
  post(path, value).then(function(Response) {
    console.log(Response.data)
  }, function(Response) {
    error(Response);
  });
}

export {
  insertMessage,
}



// WEBPACK FOOTER //
// ./src/api/message.js